/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import RouteNames from '../../../appAuthorized/RouteNames';

import AppNavTextInput from './AppNavTextInput';
import Icons from '../../icons/Icons';
import { useNavigate } from '../../../hooks/useNavigate';
import { useHealthEntryForActiveProfile } from '../../../hooks/useHealthEntry';

interface Props {
  match: any;
  intl: any;
  isEditable?: boolean;
}
const AppNavAnatomyTextInput = (props) => {
  const { intl, isEditable } = props;
  const healthEntryId = Number(props.match.params.healthEntryId);

  const [, navActions] = useNavigate();
  const [, heActions] = useHealthEntryForActiveProfile(healthEntryId);
  const healthEntry = heActions.instantiateHealthEntry();

  return (
    <AppNavTextInput
      icon={<Icons.Anatomy lineHeight="18px" color="white" />}
      value={healthEntry.anatomy.hasAnatomy() ? healthEntry.anatomy.formattedNames() : ''}
      placeholder={intl.formatMessage({ id: 'healthEntry.definingAnatomy.field.label' })}
      onClear={() => {
        const anatomy = healthEntry.anatomy.get();
        healthEntry.anatomy.remove(anatomy.id);
        heActions.apiUpdate(healthEntry.data());
      }}
      onClick={() => {
        navActions.goTo(RouteNames.healthEntryAnatomy(healthEntryId));
      }}
      isEditable={isEditable}
    />
  );
};

export default withRouter(injectIntl(AppNavAnatomyTextInput));
